import { Languages } from "../../../enums/languages";


const otpModalLang = {
    "modal-title": {
        [Languages.Hebrew]: { default: "אימות דו-שלבית" },
        [Languages.Arabic]: { default: "التحقق بخطوتين" },
        [Languages.English]: { default: "Two-Step Verification" }
    },
    "description": {
        "line-1": {
            [Languages.Hebrew]: { default: "לביצוע פעולה זו נדרש קודם לאתר את " },
            [Languages.Arabic]: { default: "لتنفيذ هذا الإجراء، يجب أولاً تحديد " },
            [Languages.English]: { default: "To update vehicle details in an existing permit, you must first locate the " }
        },
        "line-2": {
            [Languages.Hebrew]: { default: "אנא הזן את הפרטים הבאים לפי " },
            [Languages.Arabic]: { default: "يرجى إدخال التفاصيل التالية وفقًا لـ" },
            [Languages.English]: { default: "To do so, please enter the following details according to the " }
        },
        'permit': {
            [Languages.Hebrew]: { default: "התו הקיים" },
            [Languages.Arabic]: { default: "التصريح الحالي" },
            [Languages.English]: { default: "existing permit" }
        },
        'request': {
            [Languages.Hebrew]: { default: "הבקשה הקיימת" },
            [Languages.Arabic]: { default: "الطلب الحالي" },
            [Languages.English]: { default: "existing request" }
        },
        "otp-msg": {
            "first-part": {

                [Languages.Hebrew]: { default: "לצורך אימות, ישלח קוד אימות זמני" },
                [Languages.Arabic]: { default: "لأغراض التحقق، سيتم إرسال رمز تحقق مؤقت" },
                [Languages.English]: { default: "For verification purposes, a temporary OTP code will be sent" }
            },
            "via": {
                "SMS": {
                    [Languages.Hebrew]: { default: "למספר הטלפון" },
                    [Languages.Arabic]: { default: "إلى رقم الهاتف" },
                    [Languages.English]: { default: "to the phone number" }
                },
                "EMAIL": {
                    [Languages.Hebrew]: { default: "לכתובת המייל" },
                    [Languages.Arabic]: { default: "إلى عنوان البريد الإلكتروني" },
                    [Languages.English]: { default: "to the email address" }
                },
            },
            "last-part": {
                "SMS": {
                    [Languages.Hebrew]: { default: "אשר רשום אצלנו במערכת" },
                    [Languages.Arabic]: { default: "الذي مسجل لدينا في النظام" },
                    [Languages.English]: { default: "which is registered with us in the system" }
                },
                "EMAIL": {
                    [Languages.Hebrew]: { default: "אשר רשומה אצלנו במערכת" },
                    [Languages.Arabic]: { default: "الذي مسجل لدينا في النظام" },
                    [Languages.English]: { default: "which is registered with us in the system" }
                }
            }
        },
    },
    "actions": {
        "UPDATE_VEHICLE_DETAILS": {
            "modal-sub-title": {
                [Languages.Hebrew]: { default: "עידכון פרטי רכב בתו קיים" },
                [Languages.Arabic]: { default: "تحديث معلومات السيارة في التصريح الحالي" },
                [Languages.English]: { default: "Update Vehicle Details in Existing Permit" }
            },
        },
        "RENEWED_PERMIT_OPTION": {
            "modal-sub-title": {
                [Languages.Hebrew]: { default: "חידוש תו קיים" },
                [Languages.Arabic]: { default: "تجديد تصريح حالي" },
                [Languages.English]: { default: "Renew Existing Permit" }
            },
        },
        "ADD_FILE_TO_REQUEST": {
            "modal-sub-title": {
                [Languages.Hebrew]: { default: "הוספת קובץ לבקשה קיימת" },
                [Languages.Arabic]: { default: "إضافة ملف إلى طلب حالي" },
                [Languages.English]: { default: "Add File to Existing Request" }
            },
        },
        "CHECK_REQUEST_STATUS": {
            "modal-sub-title": {
                [Languages.Hebrew]: { default: "בדיקת סטטוס בקשה קיימת" },
                [Languages.Arabic]: { default: "التحقق من حالة الطلب الحالي" },
                [Languages.English]: { default: "Check Existing Request Status" }
            },
        },
        "CANCEL_PERMIT": {
            "modal-sub-title": {
                [Languages.Hebrew]: { default: "ביטול תו קיים" },
                [Languages.Arabic]: { default: "إلغاء تصريح حالي" },
                [Languages.English]: { default: "Cancel Existing Permit" }
            },
        },
        "CHECK_PEMIT_VALIDITY": {
            "modal-sub-title": {
                [Languages.Hebrew]: { default: "בדיקת תוקף תו קיים" },
                [Languages.Arabic]: { default: "التحقق من صلاحية التصريح الحالي" },
                [Languages.English]: { default: "Check Existing Permit Validity" }
            },
        }
    },
    "form": {
        "vehicle-num-input-label": {
            [Languages.Hebrew]: { default: "מספר רכב" },
            [Languages.Arabic]: { default: "رقم السيارة" },
            [Languages.English]: { default: "Vehicle Number" }
        },
        "person-id-input-label": {
            [Languages.Hebrew]: { default: "מספר תעודת זהות" },
            [Languages.Arabic]: { default: "رقم الهوية الشخصية" },
            [Languages.English]: { default: "Personal ID Number" }
        },
        "otp-input-label": {
            "email": {
                [Languages.Hebrew]: { default: "קוד אימות (נשלח למייל)" },
                [Languages.Arabic]: { default: "رمز التحقق (تم إرساله إلى البريد الإلكتروني)" },
                [Languages.English]: { default: "OTP Code (sent to email)" }
            },
            "sms": {
                [Languages.Hebrew]: { default: "קוד אימות (נשלח לסלולרי)" },
                [Languages.Arabic]: { default: "رمز التحقق (تم إرساله إلى الهاتف المحمول)" },
                [Languages.English]: { default: "OTP Code (sent to mobile)" }
            }
        },
        "otp-helper": {
            "EMAIL": {
                [Languages.Hebrew]: { default: "קוד האימות נשלח לכתובת המייל:" },
                [Languages.Arabic]: { default: "سيتم إرسال رمز التحقق إلى بريدك الإلكتروني." },
                [Languages.English]: { default: "The verification code will be sent to your email address." }
            },
            "SMS": {
                [Languages.Hebrew]: { default: "קוד האימות יישלח למספר הטלפון:" },
                [Languages.Arabic]: { default: "سيتم إرسال رمز التحقق إلى رقم هاتفك." },
                [Languages.English]: { default: "The verification code will be sent to your phone number." }
            },
            "otpCode": {
                [Languages.Hebrew]: { default: "הזן את קוד האימות שקיבלת." },
                [Languages.Arabic]: { default: "أدخل رمز التحقق الذي تلقيته." },
                [Languages.English]: { default: "Enter the OTP code you received." }
            }
        },
        "btns": {
            "send-otp-code": {
                [Languages.Hebrew]: { default: "שלח קוד אימות" },
                [Languages.Arabic]: { default: "إرسال رمز التحقق" },
                [Languages.English]: { default: "Send OTP Code" }
            },
            "check-otp-code": {
                [Languages.Hebrew]: { default: "בדוק קוד אימות" },
                [Languages.Arabic]: { default: "تحقق من رمز التحقق" },
                [Languages.English]: { default: "Check OTP Code" }
            },
            "reset-form-details": {
                [Languages.Hebrew]: { default: "איפוס פרטי הטופס" },
                [Languages.Arabic]: { default: "إعادة تعيين تفاصيل النموذج" },
                [Languages.English]: { default: "Reset Form Details" }
            },
        },
        "warning": {
            "canceling-permit": {
                [Languages.Hebrew]: { default: "ידוע לך כי ביצוע הפעולה יגרע את תו הדייר שפרטיו תזין למערכת." },
                [Languages.Arabic]: { default: "أنت على علم بأن تنفيذ هذا الإجراء سيؤدي إلى خصم تصريح المقيم الذي ستدخله في النظام." },
                [Languages.English]: { default: "You are aware that performing this action will deduct the resident permit whose details you enter into the system." }
            },
            "renewed-permit": {
                [Languages.Hebrew]: { default: "ניתן לחדש תו אשר הונפק במהלך 2025 ותאריך הסיום שלו הוא עד 31/12/2025 בלבד." },
                [Languages.Arabic]: { default: "يمكن تجديد تصريح تم إصداره خلال عام 2025 وتاريخ انتهائه حتى 31/12/2025 فقط." },
                [Languages.English]: { default: "Only permits issued during 2025 with an expiration date of up to 31/12/2025 can be renewed." }
            }
        }
    }
};

export default otpModalLang;